import TuneIcon from '@mui/icons-material/Tune';
import { SvgIconProps } from '@mui/material';

/**
 * Wraps MUI's TuneIcon so it can be rendered via TAGSvgIcon (icon="Tune").
 */
export default function Tune(props: SvgIconProps) {
  return <TuneIcon {...props} data-sentry-element="TuneIcon" data-sentry-component="Tune" data-sentry-source-file="Tune.tsx" />;
}